module.exports = __webpack_public_path__ + "assets/background.543291514bf338a5e28c857d7c535e90.jpg";